import { generateSART, EventBus, EventRepeater, TimedEvent, Timer } from "./utils";
import { InputTracking } from "./utils/InputTracking";
import { SARTParams } from "./types/SARTParams";

const getTotalTime = (config:SARTParams) => {
	let { displayTime, pause, values } = config;
	return pause + (displayTime + pause) * values;
};

export class SARTPlayer {

	constructor(config:SARTParams){
		const { displayTime, pause, values } = config;
		const totalTime = getTotalTime(config);
		this._displayValues = generateSART(config);
		this._showValueRepeater = new EventRepeater(values, pause, displayTime + pause, () => this.showValue());
		this._hideValueRepeater = new EventRepeater(values, pause + displayTime, pause + displayTime, () => this.hideValue());
		this._endEvent = new TimedEvent(totalTime, () => this.onEnd());
	}

	public on (name:string, fn:Function){ this._events.on(name, fn) }
	public off (name:string, fn:Function){ this._events.off(name, fn) }

	public start(){
		this.reset();
		this._timer.start();
		this._input.start();
		this._showValueRepeater.start();
		this._hideValueRepeater.start();
		this._endEvent.run();
	};

	public stop(){ this.reset(); };

	public exportData(){
		return {
			values: this._displayValues,
			response: this._input.getKeyPresses()
		};
	};

	public dispose(){ this._input.dispose(); }

	private _displayValues:number[] = [];
	private _showValueRepeater:EventRepeater;
	private _hideValueRepeater:EventRepeater;
	private _endEvent:TimedEvent;
	private _events:EventBus = new EventBus();
	private _timer:Timer = new Timer();
	private _input:InputTracking = new InputTracking();

	private reset(){
		this._showValueRepeater.cancel();
		this._hideValueRepeater.cancel();
		this._endEvent.cancel();
	}

	private onEnd(){
		this._events.emit("end", this.exportData());
	}

	private getCurrentValue(){
		let i = this._showValueRepeater.getIndex();
		return i > -1 ? this._displayValues[i] : undefined;
	}

	private showValue(){
		this._events.emit("value", this.getCurrentValue());
	};

	private hideValue(){
		this._events.emit("value", undefined);
	}

}